import React from 'react';

export default function Privacy() {
  return (
    <main>
      <div className="page-header">
        <div className="container">
          <h1>개인정보처리방침</h1>
          <p>주식회사 허브는 이용자의 개인정보를 중요시합니다</p>
        </div>
      </div>
      <section className="section">
        <div className="container" style={{ maxWidth: 800 }}>
          <div style={{ lineHeight: 1.9, color: 'var(--gray-700)', fontSize: '0.92rem' }}>
            <h3 style={{ color: 'var(--navy-800)', margin: '1.5rem 0 0.75rem', fontSize: '1.1rem' }}>1. 수집하는 개인정보 항목</h3>
            <p>회사는 견적 상담 및 채용 지원을 위해 이름, 연락처, 이메일, 회사명 등 필수 정보를 수집합니다.</p>
            <h3 style={{ color: 'var(--navy-800)', margin: '1.5rem 0 0.75rem', fontSize: '1.1rem' }}>2. 개인정보의 수집 및 이용 목적</h3>
            <p>수집된 정보는 상담 응대, 채용 절차 진행, 서비스 안내 목적으로만 사용되며 목적 외 용도로 사용되지 않습니다.</p>
            <h3 style={{ color: 'var(--navy-800)', margin: '1.5rem 0 0.75rem', fontSize: '1.1rem' }}>3. 개인정보의 보유 및 이용 기간</h3>
            <p>수집된 개인정보는 목적 달성 후 지체 없이 파기하며, 관련 법령에 따라 일정 기간 보관이 필요한 경우 해당 기간 동안 안전하게 보관합니다.</p>
            <p style={{ marginTop: '2rem', color: 'var(--gray-500)', fontSize: '0.85rem' }}>
              본 페이지는 샘플 템플릿입니다. 실제 운영 시 법무 검토를 받은 내용으로 교체하시기 바랍니다.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
